var map = {
	"./argos-hotspot-component copy.json": 100,
	"./argos-hotspot-component.json": 101,
	"./case-studies copy.json": 102,
	"./case-studies.json": 24,
	"./credits.json": 38,
	"./iglu-ski-site-redesign.json": 103,
	"./john-lewis-discovery.json": 104,
	"./john-lewis-my-reviews.json": 105,
	"./planet-cruise-online-booking copy.json": 106,
	"./planet-cruise-online-booking.json": 107,
	"./wiggle-checkout-redesign.json": 108,
	"./wiggle-mobile-improvments.json": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;